export const taskKeys = {
  all: ["tasks"] as const,
  lists: () => [...taskKeys.all, "list"] as const,
  byCase: (caseId: string) => [...taskKeys.all, "byCase", caseId] as const,
  byAssignee: (userId: string) => [...taskKeys.all, "byAssignee", userId] as const,
  templates: () => [...taskKeys.all, "templates"] as const,
} as const;
